export default function parseDate(str) {
  const parsed = Date.parse(str)
  const date = new Date(parsed)

  const month = date.getMonth() + 1
  const day = date.getDate()
  const year = date.getFullYear()

  return `${month}/${day}/${year}`
}



// WEBPACK FOOTER //
// ./src/helpers/parseDate.js